import { render, staticRenderFns } from "./cmpconsultarpedidos.vue?vue&type=template&id=dcb081a8&"
import script from "./cmpconsultarpedidos.vue?vue&type=script&lang=js&"
export * from "./cmpconsultarpedidos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports